export default "__VITE_ASSET__50776822__"